<template>
	<div class="breadcrumb-cls">
		<span class="label-cls">当前位置：</span>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>{{item.resource.name}}</el-breadcrumb-item>
			<el-breadcrumb-item v-for="(_item, index) in item.nodeNames.split(',')" :key="index">{{_item}}</el-breadcrumb-item>
		</el-breadcrumb>
		<span class="appendix">
			<el-button @click.stop="handleEdit" v-if="currentNode.right == 6 || item.lock == '0'" size="mini">修改</el-button>
			<el-tooltip class="item" effect="dark" content="修改审核中，已锁定" placement="bottom">
				<el-button v-if="item.lock == 1 && currentNode.right == 1" size="mini" icon="el-icon-lock"></el-button>
			</el-tooltip>
		</span>
		<span class="appendix" v-if="$$(item, 'a', 'appendixList', 'length') > 0">
			<el-dropdown @command="handleDownLoadFile" trigger="click" placement="bottom-start">
				<i><svg-icon icon-class="KnowAppendix" /> 附件</i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(file, index) in $$(item, 'a', 'appendixList')" :key="index" :command="file">{{file.name}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</span>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'KnowledgeBreadcrumb',
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	props: ['item', 'currentNode'],
	created() {
		console.log(this.currentNode)
	},
	methods: {
		handleEdit() {
			this.$emit('EditHandleEdit');
		},
		handleDownLoadFile(command) {
			let $a = document.createElement('a');
			$a.setAttribute("href", command.url);
			$a.setAttribute("download", command.name);
			$a.setAttribute("target", "_parent");
			let evObj = document.createEvent('MouseEvents');
			evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			$a.dispatchEvent(evObj);
		}
	}
}
</script>

<style lang="scss" scoped>
.breadcrumb-cls {
	width: 100%;
	margin-top: 10px;
	margin-bottom: 10px;

	& > .label-cls {
		font-size: 14px;
		color: #606266;
		position: relative;
		top: -2px;
		vertical-align: top;
	}

	& .el-breadcrumb {
		display: inline-block;
		width: calc(100% - 200px);
		overflow: hidden;
		text-overflow: ellipsis;

		& > .el-breadcrumb__item {
			margin-bottom: 10px;
		}
	}

	& > .appendix {
		float: right;
		width: 50px;
		text-align: right;
		cursor: pointer;
		& i {
			font-style: normal;
			color: #337EFF;
		}

		& .el-button {
			margin-top: -10px;
		}
	}
}
</style>